module.exports = __webpack_public_path__ + "img/btn_blue_resting.d650668f.webp";